import QuestionTypes from 'models/QuestionTypes';
import { QuestionSummaryMultipleChoice } from './QuestionSummaryMultipleChoice';
import { QuestionSummaryMultipleChoiceWithText } from './QuestionSummaryMultipleChoiceWithText';

export const QuestionSummary = (props) => {

  const {question, onClickCallback} = props;

  const handleClick = () => {
    onClickCallback(question.index());
  }

  switch (question.type()){
    case QuestionTypes.MultipleChoice:
      return <QuestionSummaryMultipleChoice
        question={question}
        onClick={handleClick}
      />;
    case QuestionTypes.MultipleChoiceWithText:
      return <QuestionSummaryMultipleChoiceWithText
        question={question}
        onClick={handleClick}
      />;
    default:
      return <QuestionSummaryMultipleChoice
        question={question}
        onClick={handleClick}
      />;
  }
}
  